import { render, staticRenderFns } from "./UpdateContactStatus.vue?vue&type=template&id=31ff7349&scoped=true&lang=pug"
import script from "./UpdateContactStatus.vue?vue&type=script&lang=js"
export * from "./UpdateContactStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff7349",
  null
  
)

export default component.exports